"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var PartnersListCtl = /** @class */ (function (_super) {
    __extends(PartnersListCtl, _super);
    function PartnersListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.login; });
        _this.dk_name = UIUtils_1.UIUtils.IProp2Str(function (o) { o.name; });
        _this.dk_surname = UIUtils_1.UIUtils.IProp2Str(function (o) { o.surname; });
        _this.dk_fathername = UIUtils_1.UIUtils.IProp2Str(function (o) { o.fathername; });
        _this.dk_email = UIUtils_1.UIUtils.IProp2Str(function (o) { o.email; });
        _this.dk_phone = UIUtils_1.UIUtils.IProp2Str(function (o) { o.phone; });
        _this.dk_skype = UIUtils_1.UIUtils.IProp2Str(function (o) { o.skype; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_birthday_day = UIUtils_1.UIUtils.IProp2Str(function (o) { o.birthday_day; });
        _this.dk_birthday_month = UIUtils_1.UIUtils.IProp2Str(function (o) { o.birthday_month; });
        _this.dk_birthday_year = UIUtils_1.UIUtils.IProp2Str(function (o) { o.birthday_year; });
        _this.dk_sex = UIUtils_1.UIUtils.IProp2Str(function (o) { o.sex; });
        _this.dk_affilate_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.affilate_id; });
        _this.dk_affilate_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.affilate_title; });
        _this.dk_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_id; });
        _this.dk_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_language_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_id; });
        _this.dk_language_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_title; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_is_for_brand_stat = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_for_brand_stat; });
        _this.dk_is_email_confirmed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_email_confirmed; });
        _this.dk_child_players_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.child_players_count; });
        _this.dk_child_partners_count_level_one = UIUtils_1.UIUtils.IProp2Str(function (o) { o.child_partners_count_level_one; });
        _this.dk_child_partners_count_level_all = UIUtils_1.UIUtils.IProp2Str(function (o) { o.child_partners_count_level_all; });
        _this.dk_balance_current = UIUtils_1.UIUtils.IProp2Str(function (o) { o.balance_current; });
        _this.dk_balance_next = UIUtils_1.UIUtils.IProp2Str(function (o) { o.balance_next; });
        _this.dk_offer_inheritance_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.offer_inheritance_type_code; });
        _this.dk_offer_inheritance_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.offer_inheritance_type_title; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this.dk_top_partner_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.top_partner_id; });
        _this.dk_top_partner_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.top_partner_login; });
        _this.dk_is_allow_to_control_streamers = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_allow_to_control_streamers; });
        _this.dk_is_all_partner_players_is_suspicious = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_all_partner_players_is_suspicious; });
        _this.dk_is_log_partner_player_actions = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_log_partner_player_actions; });
        _this.dk_is_consider_registration_after_auth_only = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_consider_registration_after_auth_only; });
        _this.dk_is_allow_to_show_full_length_reports = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_allow_to_show_full_length_reports; });
        _this._errDialog = errDialog;
        return _this;
    }
    PartnersListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    PartnersListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "partner with id [" + id + "] not found !";
    }; //allAffilates: boolean, affilateIdList: number[], Offset: number, Limit: number,
    PartnersListCtl.prototype.LoadData = function (filter, onDone) {
        var _this = this;
        webAApi_1.ListPProgramPartnersByPProgramsGet.exec({
            all_pprograms: filter.all_pprograms,
            pprogram_id_list: filter.pprogram_id_list,
            offset: filter.offset,
            limit: filter.limit,
            is_filter_email_part: filter.is_filter_email_part,
            email_part: filter.email_part,
            is_filter_login_part: filter.is_filter_login_part,
            login_part: filter.login_part
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    login: resp.list[i].login,
                    name: resp.list[i].name,
                    surname: resp.list[i].surname,
                    fathername: resp.list[i].fathername,
                    email: resp.list[i].email,
                    phone: resp.list[i].phone,
                    skype: resp.list[i].skype,
                    is_locked: resp.list[i].is_locked,
                    birthday_day: resp.list[i].birthday_day,
                    birthday_month: resp.list[i].birthday_month,
                    birthday_year: resp.list[i].birthday_year,
                    sex: resp.list[i].sex,
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_title: resp.list[i].app_currency_title,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    affilate_id: resp.list[i].pprogram_id,
                    affilate_title: resp.list[i].pprogram_title,
                    app_language_id: resp.list[i].app_language_id,
                    app_language_title: resp.list[i].app_language_title,
                    description: resp.list[i].description,
                    is_for_brand_stat: resp.list[i].is_for_brand_stat,
                    is_email_confirmed: resp.list[i].is_email_confirmed,
                    child_players_count: resp.list[i].child_players_count,
                    child_partners_count_level_one: resp.list[i].child_partners_count_level_one,
                    child_partners_count_level_all: resp.list[i].child_partners_count_level_all,
                    balance_current: resp.list[i].balance_current,
                    balance_next: resp.list[i].balance_next,
                    offer_inheritance_type_code: resp.list[i].offer_inheritance_type_code,
                    offer_inheritance_type_title: resp.list[i].offer_inheritance_type_title,
                    top_partner_id: resp.list[i].top_partner_id,
                    top_partner_login: resp.list[i].top_partner_login,
                    is_allow_to_control_streamers: resp.list[i].is_allow_to_control_streamers,
                    is_all_partner_players_is_suspicious: resp.list[i].is_all_partner_players_is_suspicious,
                    is_log_partner_player_actions: resp.list[i].is_log_partner_player_actions,
                    is_consider_registration_after_auth_only: resp.list[i].is_consider_registration_after_auth_only,
                    is_allow_to_show_full_length_reports: resp.list[i].is_allow_to_show_full_length_reports
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PartnersListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPProgramPartner.exec({
            pprogram_id: data.affilate_id,
            app_currency_id: data.app_currency_id,
            login: data.login,
            password: data.password,
            name: data.name,
            surname: data.surname,
            fathername: data.fathername,
            email: data.email,
            phone: data.phone,
            skype: data.skype,
            is_locked: data.is_locked,
            birthday_day: data.birthday_day,
            birthday_month: data.birthday_month,
            birthday_year: data.birthday_year,
            sex: data.sex,
            app_language_id: data.app_language_id,
            description: data.description,
            is_for_brand_stat: data.is_for_brand_stat,
            is_email_confirmed: data.is_email_confirmed,
            offer_inheritance_type_code: data.offer_inheritance_type_code,
            is_allow_to_control_streamers: data.is_allow_to_control_streamers,
            is_all_partner_players_is_suspicious: data.is_all_partner_players_is_suspicious,
            is_log_partner_player_actions: data.is_log_partner_player_actions,
            is_consider_registration_after_auth_only: data.is_consider_registration_after_auth_only,
            is_allow_to_show_full_length_reports: data.is_allow_to_show_full_length_reports
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                login: data.login,
                name: data.name,
                surname: data.surname,
                fathername: data.fathername,
                email: data.email,
                phone: data.phone,
                skype: data.skype,
                is_locked: data.is_locked,
                birthday_day: data.birthday_day,
                birthday_month: data.birthday_month,
                birthday_year: data.birthday_year,
                sex: data.sex,
                app_currency_id: data.app_currency_id,
                app_currency_title: resp.app_currency_title,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                affilate_id: data.affilate_id,
                affilate_title: resp.pprogram_title,
                app_language_id: data.app_language_id,
                app_language_title: resp.app_language_title,
                description: data.description,
                is_for_brand_stat: data.is_for_brand_stat,
                is_email_confirmed: data.is_email_confirmed,
                child_players_count: 0,
                child_partners_count_level_one: 0,
                child_partners_count_level_all: 0,
                balance_current: 0,
                balance_next: 0,
                offer_inheritance_type_code: data.offer_inheritance_type_code,
                offer_inheritance_type_title: resp.offer_inheritance_type_title,
                top_partner_id: resp.top_partner_id,
                top_partner_login: resp.top_partner_login,
                is_allow_to_control_streamers: data.is_allow_to_control_streamers,
                is_all_partner_players_is_suspicious: data.is_all_partner_players_is_suspicious,
                is_log_partner_player_actions: data.is_log_partner_player_actions,
                is_consider_registration_after_auth_only: data.is_consider_registration_after_auth_only,
                is_allow_to_show_full_length_reports: data.is_allow_to_show_full_length_reports
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PartnersListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditPProgramPartner.exec({
                partner_id: data.key,
                app_language_id: data.app_language_id,
                name: data.name,
                surname: data.surname,
                fathername: data.fathername,
                email: data.email,
                phone: data.phone,
                skype: data.skype,
                is_locked: data.is_locked,
                birthday_day: data.birthday_day,
                birthday_month: data.birthday_month,
                birthday_year: data.birthday_year,
                sex: data.sex,
                description: data.description,
                is_for_brand_stat: data.is_for_brand_stat,
                is_email_confirmed: data.is_email_confirmed,
                offer_inheritance_type_code: data.offer_inheritance_type_code,
                is_allow_to_control_streamers: data.is_allow_to_control_streamers,
                is_all_partner_players_is_suspicious: data.is_all_partner_players_is_suspicious,
                is_log_partner_player_actions: data.is_log_partner_player_actions,
                is_consider_registration_after_auth_only: data.is_consider_registration_after_auth_only,
                is_allow_to_show_full_length_reports: data.is_allow_to_show_full_length_reports
            }, function (resp) {
                _tmp.name = data.name;
                _tmp.surname = data.surname;
                _tmp.fathername = data.fathername;
                _tmp.email = data.email;
                _tmp.phone = data.phone;
                _tmp.is_locked = data.is_locked;
                _tmp.birthday_day = data.birthday_day;
                _tmp.birthday_month = data.birthday_month;
                _tmp.birthday_year = data.birthday_year;
                _tmp.sex = data.sex;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.description = data.description;
                _tmp.app_language_id = data.app_language_id;
                _tmp.app_language_title = resp.app_language_title;
                _tmp.is_for_brand_stat = data.is_for_brand_stat;
                _tmp.offer_inheritance_type_code = data.offer_inheritance_type_code;
                _tmp.offer_inheritance_type_title = resp.offer_inheritance_type_title;
                _tmp.is_allow_to_control_streamers = data.is_allow_to_control_streamers;
                _tmp.is_all_partner_players_is_suspicious = data.is_all_partner_players_is_suspicious;
                _tmp.is_log_partner_player_actions = data.is_log_partner_player_actions;
                _tmp.is_consider_registration_after_auth_only = data.is_consider_registration_after_auth_only;
                _tmp.is_allow_to_show_full_length_reports = data.is_allow_to_show_full_length_reports;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PartnersListCtl.prototype.DeletePlayer = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletePProgramPartner.exec({
                usr_partner_id: key,
            }, function (resp) {
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PartnersListCtl.prototype.GetPartnerPassword = function (key, onDone) {
        var _this = this;
        webAApi_1.DoGetPProgramPartnerPassword.exec({ partner_id: key }, function (resp) {
            if (onDone) {
                onDone(resp.password);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PartnersListCtl.prototype.GeneratePartnerPassword = function (onDone) {
        var _this = this;
        webAApi_1.DoGeneratePProgramPartnerPassword.exec({}, function (resp) {
            if (onDone) {
                onDone(resp.password);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PartnersListCtl.prototype.SetPartnerIsLocked = function (key, IsLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPProgramPartnerIsLocked.exec({
                partner_id: key,
                is_locked: IsLocked
            }, function (resp) {
                _tmp.is_locked = IsLocked;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PartnersListCtl.prototype.SetPartnerNewPassword = function (key, newPassword, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPProgramPartnerNewPassword.exec({
                partner_id: key,
                new_password: newPassword
            }, function (resp) {
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PartnersListCtl.prototype.SetTopPartner = function (key, partner, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetUsrPartnerTopPartner.exec({
                usr_partner_id: key,
                top_partner_id: partner
            }, function (resp) {
                _tmp.top_partner_id = partner;
                _tmp.top_partner_login = resp.top_partner_login;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return PartnersListCtl;
}(BaseController_1.BaseController));
exports.PartnersListCtl = PartnersListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_partners_list/ctl/PartnersListCtl.ts
// module id = 963
// module chunks = 0